/* ALCO 12-oct-2026 · Buscador con sugerencias mientras se escribe.
   1) Cabecera: usa el componente <predictive-search> de Dawn (predictive-search.js); aquí sólo se le
      pide un mínimo de 2 letras y se muestra «Lo más buscado» cuando la caja está vacía.
   2) Portada (form.alco-hero__buscador) o cualquier form[data-alco-sugerencias]: mismo resultado de
      Shopify (/search/suggest + sección predictive-search) en un panel propio que cuelga del <body>,
      porque la portada recorta (overflow: hidden) lo que se sale de su recuadro.
   Enter sin elegir una sugerencia = búsqueda normal (el form se envía como siempre). */
(function () {
  if (window.__alcoBuscador) return;
  window.__alcoBuscador = true;

  var MIN = 2;
  var urlSug = function () { return (window.routes && window.routes.predictive_search_url) || '/search/suggest'; };
  /* hasta 5 productos, 5 colecciones y 5 búsquedas; los agotados al final */
  function urlConsulta(q) {
    return urlSug() + '?q=' + encodeURIComponent(q) +
      '&resources%5Btype%5D=product%2Ccollection%2Cquery&resources%5Blimit%5D=5&resources%5Blimit_scope%5D=each' +
      '&resources%5Boptions%5D%5Bunavailable_products%5D=last&section_id=predictive-search';
  }
  function llaveCache(q) { return q.replace(' ', '-').toLowerCase(); }

  /* pone en negritas la(s) palabra(s) escrita(s), sin importar mayúsculas ni acentos */
  function sinAcentos(s) { return s.normalize ? s.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : s; }
  function esc(s) { return s.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function resaltar(raiz, termino) {
    var palabras = sinAcentos(termino || '').toLowerCase().split(/\s+/).filter(function (p) { return p.length >= 2; });
    if (!raiz || !palabras.length) return;
    raiz.querySelectorAll('[data-alco-resaltar]').forEach(function (el) {
      var txt = el.textContent;
      var norm = sinAcentos(txt).toLowerCase();
      if (norm.length !== txt.length) norm = txt.toLowerCase();
      var marcas = new Array(txt.length + 1).join('0').split('');
      palabras.forEach(function (p) {
        /* «platos» también marca «PLATO»; «jarras» marca «JARRA» */
        if (norm.indexOf(p) === -1 && /es$/.test(p) && p.length > 4 && norm.indexOf(p.slice(0, -2)) !== -1) p = p.slice(0, -2);
        else if (norm.indexOf(p) === -1 && /s$/.test(p) && p.length > 3) p = p.slice(0, -1);
        var i = norm.indexOf(p);
        while (i !== -1) { for (var k = i; k < i + p.length; k++) marcas[k] = '1'; i = norm.indexOf(p, i + p.length); }
      });
      if (marcas.indexOf('1') === -1) return;
      var html = '', dentro = false;
      for (var j = 0; j < txt.length; j++) {
        var m = marcas[j] === '1';
        if (m && !dentro) { html += '<strong class="alco-ps__marca">'; dentro = true; }
        if (!m && dentro) { html += '</strong>'; dentro = false; }
        html += esc(txt[j]);
      }
      if (dentro) html += '</strong>';
      el.innerHTML = html;
    });
  }

  /* ---------- 1) Cabecera (Dawn) ---------- */
  function largo(input) { return input ? input.value.trim().length : 0; }

  function marcarVacio(ps) {
    var input = ps.querySelector('input[type="search"]');
    if (largo(input) < MIN) {
      ps.setAttribute('data-vacio', '');
      if (largo(input) > 0) ps.removeAttribute('results');
    } else {
      ps.removeAttribute('data-vacio');
    }
  }

  function prepararCabecera() {
    document.querySelectorAll('.header__search predictive-search, .header__search search-form').forEach(function (ps) {
      if (ps.__alco) return;
      ps.__alco = true;
      marcarVacio(ps);
      ['input', 'keyup', 'focusin'].forEach(function (ev) { ps.addEventListener(ev, function () { marcarVacio(ps); }); });
      ps.addEventListener('reset', function () { setTimeout(function () { marcarVacio(ps); }); }, true);
      ps.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-alco-pop]');
        if (!chip) return;
        e.preventDefault();
        var input = ps.querySelector('input[type="search"]');
        input.value = chip.getAttribute('data-alco-pop');
        input.focus();
        input.dispatchEvent(new Event('input', { bubbles: true }));
        marcarVacio(ps);
      });
    });
  }

  customElements.whenDefined('predictive-search').then(function () {
    var PS = customElements.get('predictive-search');
    if (PS && !PS.prototype.__alcoMin) {
      PS.prototype.__alcoMin = true;
      /* misma lógica que Dawn, con mínimo de 2 letras y la consulta ampliada (5 productos + colecciones) */
      PS.prototype.getSearchResults = function (termino) {
        var self = this;
        if ((termino || '').length < MIN) {
          this.closeResults(false);
          this.removeAttribute('results');
          return;
        }
        var llave = llaveCache(termino);
        this.setLiveRegionLoadingState();
        if (this.cachedResults[llave]) { this.renderSearchResults(this.cachedResults[llave]); return; }
        fetch(urlConsulta(termino), { signal: this.abortController.signal })
          .then(function (r) { if (!r.ok) { self.close(); throw new Error('HTTP ' + r.status); } return r.text(); })
          .then(function (texto) {
            var sec = new DOMParser().parseFromString(texto, 'text/html').querySelector('#shopify-section-predictive-search');
            var html = sec ? sec.innerHTML : '';
            self.allPredictiveSearchInstances.forEach(function (ps) { if (ps.cachedResults) ps.cachedResults[llave] = html; });
            self.renderSearchResults(html);
          })
          .catch(function (e) { if (e && (e.code === 20 || e.name === 'AbortError')) return; self.close(); });
      };
      var pintarDawn = PS.prototype.renderSearchResults;
      PS.prototype.renderSearchResults = function (html) {
        pintarDawn.call(this, html);
        resaltar(this.predictiveSearchResults, this.getQuery());
      };
    }
  });

  /* ---------- 2) Portada y otros buscadores ---------- */
  var cuenta = 0;

  function mejorar(form) {
    if (form.__alcoSug) return;
    var input = form.querySelector('input[type="search"], input[name="q"]');
    if (!input) return;
    form.__alcoSug = true;
    var uid = 'alco-sug-' + (++cuenta);
    var panel = document.createElement('div');
    panel.className = 'alco-sug-panel';
    panel.id = uid;
    panel.hidden = true;
    document.body.appendChild(panel);
    var estado = document.createElement('span');
    estado.className = 'visually-hidden';
    estado.setAttribute('role', 'status');
    estado.setAttribute('aria-live', 'polite');
    form.appendChild(estado);

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-haspopup', 'listbox');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', uid);
    input.setAttribute('autocomplete', 'off');

    var cache = {};
    var ctrl = null;
    var reloj = null;
    var abierto = false;
    var cuadro = 0;

    function colocar() {
      if (!abierto) return;
      var r = form.getBoundingClientRect();
      var vw = document.documentElement.clientWidth;
      var ancho = vw >= 990 ? Math.max(r.width, 860) : (vw >= 750 ? Math.max(r.width, 640) : vw - 24);
      ancho = Math.min(ancho, vw - 24);
      var izq = Math.min(Math.max(12, r.left), vw - 12 - ancho);
      panel.style.width = ancho + 'px';
      panel.style.left = (izq + window.scrollX) + 'px';
      panel.style.top = (r.bottom + window.scrollY + 8) + 'px';
      var vv = window.visualViewport;
      var fondo = vv ? vv.height + vv.offsetTop : window.innerHeight;
      panel.style.maxHeight = Math.max(220, Math.round(fondo - r.bottom - 20)) + 'px';
    }
    function alMover() {
      if (cuadro) return;
      cuadro = requestAnimationFrame(function () { cuadro = 0; colocar(); });
    }
    function abrir() {
      if (!abierto) {
        abierto = true;
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        window.addEventListener('scroll', alMover, { passive: true });
        window.addEventListener('resize', alMover);
        if (window.visualViewport) window.visualViewport.addEventListener('resize', alMover);
      }
      colocar();
    }
    function cerrar() {
      if (!abierto) return;
      abierto = false;
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      quitarSeleccion();
      window.removeEventListener('scroll', alMover);
      window.removeEventListener('resize', alMover);
      if (window.visualViewport) window.visualViewport.removeEventListener('resize', alMover);
    }
    function opciones() {
      return Array.prototype.filter.call(panel.querySelectorAll('[role="option"]'), function (el) { return el.offsetParent !== null; });
    }
    function quitarSeleccion() {
      panel.querySelectorAll('[aria-selected="true"]').forEach(function (el) { el.setAttribute('aria-selected', 'false'); });
    }
    function mover(paso) {
      var lista = opciones();
      if (!lista.length) return;
      var actual = lista.indexOf(panel.querySelector('[aria-selected="true"]'));
      var sig = actual === -1 ? (paso > 0 ? 0 : lista.length - 1) : (actual + paso + lista.length) % lista.length;
      quitarSeleccion();
      lista[sig].setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', lista[sig].id);
      lista[sig].scrollIntoView({ block: 'nearest' });
    }
    function enviar() {
      cerrar();
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    }
    function activar(op) {
      if (op.matches('button, .predictive-search__item--term')) { enviar(); return; }
      var a = op.querySelector('a[href]');
      if (a) window.location.href = a.href;
    }
    function pintar(html) {
      panel.innerHTML = html;
      panel.removeAttribute('aria-busy');
      panel.querySelectorAll('[id]').forEach(function (el) { el.id = uid + '-' + el.id; });
      panel.querySelectorAll('[aria-labelledby]').forEach(function (el) { el.setAttribute('aria-labelledby', uid + '-' + el.getAttribute('aria-labelledby')); });
      panel.querySelectorAll('.predictive-search__item--term').forEach(function (b) { b.setAttribute('type', 'button'); });
      resaltar(panel, input.value.trim());
      var conteo = panel.querySelector('[data-predictive-search-live-region-count-value]');
      estado.textContent = conteo ? conteo.textContent.replace(/\s+/g, ' ').trim() : '';
      if (!panel.querySelector('#' + uid + '-predictive-search-results')) { cerrar(); return; }
      abrir();
    }
    function buscar(q) {
      var llave = llaveCache(q);
      if (cache[llave] !== undefined) { pintar(cache[llave]); return; }
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      if (!abierto) { panel.innerHTML = '<div class="alco-sug-cargando">Buscando…</div>'; abrir(); }
      panel.setAttribute('aria-busy', 'true');
      fetch(urlConsulta(q), ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (texto) {
          var sec = new DOMParser().parseFromString(texto, 'text/html').querySelector('#shopify-section-predictive-search');
          var html = sec ? sec.innerHTML : '';
          cache[llave] = html;
          if (llaveCache(input.value.trim()) === llave && document.activeElement === input) pintar(html);
        })
        .catch(function (e) { if (e && e.name === 'AbortError') return; cerrar(); });
    }

    input.addEventListener('input', function () {
      clearTimeout(reloj);
      var q = input.value.trim();
      if (q.length < MIN) { if (ctrl) ctrl.abort(); cerrar(); return; }
      reloj = setTimeout(function () { buscar(q); }, 250);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (!abierto) { if (input.value.trim().length >= MIN) { e.preventDefault(); buscar(input.value.trim()); } return; }
        e.preventDefault();
        mover(e.key === 'ArrowDown' ? 1 : -1);
      } else if (e.key === 'Enter') {
        var sel = abierto && panel.querySelector('[aria-selected="true"]');
        if (sel) { e.preventDefault(); activar(sel); }
        else cerrar(); /* sin elegir: el form se envía normal */
      } else if (e.key === 'Escape') {
        if (abierto) { e.preventDefault(); cerrar(); }
      }
    });
    input.addEventListener('focus', function () {
      var q = input.value.trim();
      if (q.length >= MIN) buscar(q);
      if (window.innerWidth < 750) {
        /* en el celular, sube la caja para que las sugerencias quepan arriba del teclado */
        var cab = document.querySelector('.section-header');
        var alto = cab ? cab.getBoundingClientRect().height : 0;
        var r = form.getBoundingClientRect();
        var meta = window.scrollY + r.top - alto - 12;
        if (r.top > alto + 140) window.scrollTo({ top: Math.max(0, meta), behavior: 'smooth' });
      }
    });
    input.addEventListener('blur', function () { setTimeout(function () { if (document.activeElement !== input) cerrar(); }, 120); });
    form.addEventListener('submit', function () { cerrar(); });

    /* el clic dentro del panel no le quita el foco a la caja */
    panel.addEventListener('mousedown', function (e) { e.preventDefault(); });
    panel.addEventListener('click', function (e) {
      if (e.target.closest('.predictive-search__item--term')) { e.preventDefault(); enviar(); }
    });
    panel.addEventListener('mousemove', function (e) {
      var op = e.target.closest('[role="option"]');
      if (!op || op.getAttribute('aria-selected') === 'true') return;
      quitarSeleccion();
      op.setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', op.id);
    });
  }

  function iniciar() {
    prepararCabecera();
    document.querySelectorAll('form.alco-hero__buscador, form[data-alco-sugerencias]').forEach(mejorar);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();
